<template>
  <div>
    <h5>Проверка номера телефона {{ order.client.phone }}</h5>
    <p>Перед операцией необходимо проверить статус клиента в ситеме PAYMART</p>
    <div class="install-control">
      <button @click="next" class="btn btn-success">{{ 'next_step' | setText('Далее') }}</button>
    </div>
  </div>
</template>
<script>
import { logger } from '../../../plugins/functions';

export default {
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    index: {
      default: 0
    }
  },
  name: "filter",
  async created() {

  },
  methods: {

    next() {
      this.save();
    },
    prev() {
      this.$emit('next', this.index - 1);
    },
    save() {
      this.$loading(true);

      logger(this.$http, {
        name: 'Проверка пользователя #PAYMART',
        description: `Начало запроса`,
        model_type: 'order',
        model_id: this.order.id,
        partner_id: this.partner.id
      });

      this.$http
        .post(`${this.partner['endpoint_url']}buyers/verify`,
          {
            phone: this.order.client.phone
          },
          {
            headers: {
              'Authorization': `Bearer ${this.partner['api_secret_key']}`,
              'Content-Type': 'application/json'
            }
          })
        .then((response) => {

          if (response.data) {
            switch (response.data.result) {
              case 5:
                this.message = 'Не загружены фото паспорта';
                this.$emit('next', 6); // run to create order
                break;
              case 10:
                this.message = 'Не загружены фото паспорта';
                this.$emit('next', 6); // run to create order
                break;
              case 11:
                this.message = 'Не загружены фото паспорта';
                this.$emit('next', 6); // run to create order
                break;

              case 4:
                this.message = 'Клиент верефицирован';
                this.$emit('next', 8); // run to create order
                break;

              case 12:
                this.message = 'Необходимо добавить доверителей';
                this.$emit('next', 7); // run to create order
                break;

              case 8:
                this.message = 'Клиент получил отказ от систмы PAYMART или имеет блокировку.';
                break;

              case 1:
                this.$emit('next', 4);
                this.message = 'Необходимо добавить карту';
                break;

              case 2:
                this.message = 'Клиент не верефицирован. Ожидайте верификацию';
                break;

              case 0:
                this.message = 'Клиент не найден в системе PAYMART';
                setTimeout(() => {
                  this.$emit('next', 1);
                }, 10);

                break;
              default:
                this.message = 'Неизвестная ошибка';

                break;
            }

            if (response.data.buyer_id) {
              this.$emit('getBuyer', response.data.buyer_id);
              this.$emit('getLimitUser', response.data.available_balance);
            }

            if (this.message) {
              this.$notify({
                title: "PAYMART",
                message: this.message,
                icon: "ti-save",
                horizontalAlign: "right",
                verticalAlign: "top",
              });

              logger(this.$http, {
                name: 'Проверка пользователя #PAYMART',
                description: this.message,
                model_type: 'order',
                model_id: this.order.id
              });
            }
          }
        })
        .catch((error) => {

          logger(this.$http, {
            name: 'Проверка пользователя #PAYMART',
            description: `Ошибка системы #PAYMART`,
            model_type: 'order',
            model_id: this.order.id
          });

          alert('Ошибка партнера');
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      message: '',
    };
  },
};
</script>
<style lang="scss">

</style>
